// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    font-family: Georgia, "Verdana", Geneva, serif;
    margin: 0;
    height: 100%;
    /* Default 16px */
    font-size: 16px;
}

#app {
    display: flex;
    flex-direction: column;
    font-family: Georgia, "Verdana", Geneva, serif;
    height: 100vh;
    width: clamp(800px, 96%, 1080px);
    margin: 0 auto;
    padding: 0;
    /* overflow: hidden; */
}


/* Header 正常流佈局 */
.app-header {
    height: 8vh;
    position: relative;
}

/* Content 正常佈局，允許滾動 */
.app-content {
    flex: 1;
    margin: 0.5rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    /* overflow-y: auto; */
    /* padding-bottom: 7vh; */
}

/* Footer 固定在視窗底部 */
.app-footer {
    height: 7.5vh;
    width: 100%;
    /* sticky 讓元素固定在底部又符合響應式*/
    position: sticky;
    /* bottom & left 在此為 sticky 的參數 */
    bottom: 10px;
    left: 0;
}




/* @media (min-width: 820px) and (max-width: 1180px) {
    .app-header {
        height: 4vh;
    }

    .app-content {
        height: 82vh;
    }

    .app-footer {
        height: 7vh;
    }
}


@media (min-width: 1190px) {

    .app-header,
    .app-footer {
        height: 7vh;
    }
} */

/* 桌面瀏覽器：高度佔滿整個頁面，寬度使用 iPad 比例 */
/* @media (min-width: 1280px) {
    #app {
        max-width: 820px;
        margin: auto;
    }
} */`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;;IAEI,8CAA8C;IAC9C,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8CAA8C;IAC9C,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,UAAU;IACV,sBAAsB;AAC1B;;;AAGA,iBAAiB;AACjB;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,OAAO;IACP,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iCAAiC;IACjC,YAAY;IACZ,OAAO;AACX;;;;;AAKA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH,gCAAgC;AAChC;;;;;GAKG","sourcesContent":["html,\nbody {\n    font-family: Georgia, \"Verdana\", Geneva, serif;\n    margin: 0;\n    height: 100%;\n    /* Default 16px */\n    font-size: 16px;\n}\n\n#app {\n    display: flex;\n    flex-direction: column;\n    font-family: Georgia, \"Verdana\", Geneva, serif;\n    height: 100vh;\n    width: clamp(800px, 96%, 1080px);\n    margin: 0 auto;\n    padding: 0;\n    /* overflow: hidden; */\n}\n\n\n/* Header 正常流佈局 */\n.app-header {\n    height: 8vh;\n    position: relative;\n}\n\n/* Content 正常佈局，允許滾動 */\n.app-content {\n    flex: 1;\n    margin: 0.5rem;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    /* overflow-y: auto; */\n    /* padding-bottom: 7vh; */\n}\n\n/* Footer 固定在視窗底部 */\n.app-footer {\n    height: 7.5vh;\n    width: 100%;\n    /* sticky 讓元素固定在底部又符合響應式*/\n    position: sticky;\n    /* bottom & left 在此為 sticky 的參數 */\n    bottom: 10px;\n    left: 0;\n}\n\n\n\n\n/* @media (min-width: 820px) and (max-width: 1180px) {\n    .app-header {\n        height: 4vh;\n    }\n\n    .app-content {\n        height: 82vh;\n    }\n\n    .app-footer {\n        height: 7vh;\n    }\n}\n\n\n@media (min-width: 1190px) {\n\n    .app-header,\n    .app-footer {\n        height: 7vh;\n    }\n} */\n\n/* 桌面瀏覽器：高度佔滿整個頁面，寬度使用 iPad 比例 */\n/* @media (min-width: 1280px) {\n    #app {\n        max-width: 820px;\n        margin: auto;\n    }\n} */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
